import { SupportedLang } from 'app/core/services/language/language.service';

export interface ILanguageOption {
  code: SupportedLang;
  /** Código ISO mostrado como prefijo (neutro al idioma): `ES`, `EN`. */
  codeLabel: string;
  /** Key i18n del nombre del idioma; se traduce al idioma activo (no es endónimo). */
  nameKey: string;
}

/**
 * Opciones del selector de idioma, compartidas por user-menu y language-switcher
 * para que no diverjan. El nombre se traduce al idioma activo vía `nameKey`
 * (en español: "Español"/"Inglés"; en inglés: "Spanish"/"English").
 */
export const LANGUAGE_OPTIONS: readonly ILanguageOption[] = [
  { code: 'es', codeLabel: 'ES', nameKey: 'common.languageMenu.spanish' },
  { code: 'en', codeLabel: 'EN', nameKey: 'common.languageMenu.english' },
];
